module.exports = __webpack_public_path__ + "static/media/cover.55fcf067.png";